<sh-box id="instrument-box-1" style="flex-grow:0;" background="surface" layout="vertical" elevation="none" style="height: 100%">

  <sh-box-header id="instrument-box-header-2" slot="header" padding-bottom="0">
    <sh-icon id="instrument-icon-open-tasks" icon="open-tasks" size="s"
      style="margin-left: -4px; margin-right: 4px; padding-right: 1px; cursor: help;"
    (click)="openHelp('System Health')"></sh-icon>
    <div style="display: flex;align-items: center; gap: 8px">
      <sh-text id="instrument-text-4" size="title-1" style="cursor: help; width: fit-content;" (click)="openHelp('System Health')">{{ 'instrument.widget.title' | transloco }}</sh-text>
      @if (!hideStatusIcon) {
        <sh-icon id="instrument-icon-5" size="s" [icon]="getStatusIconUrl()" (click)="openDetails()" button></sh-icon>
      }
    </div>
    <!-- <sh-icon id="morefuncloc" icon="information" size="s" button [attr.aria-label]="'Infrmation Instrument Health'"></sh-icon> -->
    <sh-dropdown id="instrument-dropdown-6" no-border condensed style="max-width: 120px;" [attr.value]="(selectedRange === 7 ? 'instrument.widget.range.last7Days' : selectedRange === 14 ? 'instrument.widget.range.last14Days' : 'instrument.widget.range.last30Days') | transloco">
      <sh-menu-item id="instrument-menu-item-last-7-days" (click)="changeRange(7)" [attr.label]="'instrument.widget.range.last7Days' | transloco" [active]="selectedRange === 7"></sh-menu-item>
      <sh-menu-item id="instrument-menu-item-last-14-days" (click)="changeRange(14)" [attr.label]="'instrument.widget.range.last14Days' | transloco" [active]="selectedRange === 14"></sh-menu-item>
      <sh-menu-item id="instrument-menu-item-last-30-days" (click)="changeRange(30)" [attr.label]="'instrument.widget.range.last30Days' | transloco" [active]="selectedRange === 30"></sh-menu-item>
    </sh-dropdown>
  </sh-box-header>


  <sh-box-section id="instrument-box-section-10" style="height: 100%">
    <sh-notification-item id="instrument-notification-item-11" style="margin-bottom: 8px;" [visible]="showNotif" inline  [type]="olderThanSevenDays ? 'error' : 'warning'">
      {{ (olderThanSevenDays ? 'instrument.widget.dataNotUpdated7Days' : 'instrument.widget.dataNotUpdated3Days') | transloco }} <a style="cursor: pointer;" (click)="openDetails()">{{ 'instrument.widget.dataNotUpdatedLink' | transloco }}</a> {{ 'instrument.widget.dataNotUpdatedSuffix' | transloco }}
    </sh-notification-item>

    @if (isLoading) {
      <div
        style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
        <sh-spinner id="instrument-spinner-12" size="s"></sh-spinner>
      </div>
    }
    @if (!isLoading && systemhealth) {
      <div style="display: flex; flex-direction: row; gap: 4px; flex-wrap: wrap;">
        <div [ngClass]="'custom-parent'">
          <div [ngClass]="'iconTextContainer'">
            @if (systemhealth?.metrics?.time_windows[''+selectedRange]['maintenance'] === 0 || systemhealth?.metrics === null) {
              <sh-icon id="instrument-icon-success"
                icon="success" size="xs" color="var(--success-icon-color)" style="cursor: help;"
              (click)="openHelp('Maintenance')"></sh-icon>
            }
            @if (systemhealth?.metrics && systemhealth?.metrics?.time_windows[''+selectedRange]['maintenance'] !== 0) {
              <sh-icon id="instrument-icon-warning"
                icon="warning" size="xs" color="var(--warning-yellow)" style="cursor: help;"
              (click)="openHelp('Maintenance')"></sh-icon>
            }
            <sh-text id="instrument-text-15" [ngClass]="'custom-info'" style="cursor: pointer;"
            (click)="onMaximize('Maintenance')">{{ 'instrument.widget.maintenance' | transloco }}</sh-text>
          </div>
          @if (systemhealth?.metrics && systemhealth?.metrics?.time_windows[''+selectedRange]['maintenance'] !== 0) {
            <div (click)="onMaximize('Maintenance')"
              [ngClass]="'custom-tag'">
            {{systemhealth?.metrics?.time_windows[''+selectedRange]['maintenance']}} {{ 'instrument.widget.failures' | transloco }}</div>
          }
        </div>
        <div [ngClass]="'custom-parent'">
          <div [ngClass]="'iconTextContainer'">
            @if (systemhealth?.metrics?.time_windows[''+selectedRange]['autochecks'] === 0 || systemhealth?.metrics === null) {
              <sh-icon id="instrument-icon-success"
                icon="success" size="xs" color="var(--success-icon-color)" style="cursor: help;"
              (click)="openHelp('Autocheck')"></sh-icon>
            }
            @if (systemhealth?.metrics && systemhealth?.metrics?.time_windows[''+selectedRange]['autochecks'] !== 0) {
              <sh-icon id="instrument-icon-warning"
                icon="warning" size="xs" color="var(--warning-yellow)" style="cursor: help;"
              (click)="openHelp('Autocheck')"></sh-icon>
            }
            <sh-text id="instrument-text-18" [ngClass]="'custom-info'" style="cursor: pointer;"
            (click)="onMaximize('Autocheck')">{{ 'instrument.widget.autocheck' | transloco }}</sh-text>
          </div>
          @if (systemhealth?.metrics && systemhealth?.metrics?.time_windows[''+selectedRange]['autochecks'] !== 0) {
            <div (click)="onMaximize('Autocheck')"
              [ngClass]="'custom-tag'">
            {{systemhealth?.metrics?.time_windows[''+selectedRange]['autochecks']}} {{ 'instrument.widget.failures' | transloco }}</div>
          }
        </div>
        <div [ngClass]="'custom-parent'">
          <div [ngClass]="'iconTextContainer'">
            @if (systemhealth?.metrics?.time_windows[''+selectedRange]['error_events'] === 0 || systemhealth?.metrics === null) {
              <sh-icon id="instrument-icon-success"
                icon="success" size="xs" color="var(--success-icon-color)" style="cursor: help;"
              (click)="openHelp('Events')"></sh-icon>
            }
            @if (systemhealth?.metrics && systemhealth?.metrics?.time_windows[''+selectedRange]['error_events'] !== 0) {
              <sh-icon id="instrument-icon-warning"
                icon="warning" size="xs" color="var(--warning-icon-color)" style="cursor: help;"
              (click)="openHelp('Events')"></sh-icon>
            }
            <sh-text id="instrument-text-21" [ngClass]="'custom-info'" style="cursor: pointer;" (click)="onMaximize('Events')">{{ 'instrument.widget.errorEvents' | transloco }}</sh-text>
          </div>
          @if (systemhealth?.metrics && systemhealth?.metrics?.time_windows[''+selectedRange]['error_events'] !== 0) {
            <div (click)="onMaximize('Events')"
              [ngClass]="'custom-tag'">
            {{systemhealth?.metrics?.time_windows[''+selectedRange]['error_events']}} {{ 'instrument.widget.errors' | transloco }}</div>
          }
        </div>
        <div [ngClass]="'custom-parent'">
          <div [ngClass]="'iconTextContainer'">
            @if (systemhealth?.metrics?.time_windows[''+selectedRange]['qc'] === 0 || systemhealth?.metrics === null) {
              <sh-icon id="instrument-icon-success" icon="success"
              size="xs" color="var(--success-icon-color)" style="cursor: help;" (click)="openHelp('QC')"></sh-icon>
            }
            @if (systemhealth?.metrics && systemhealth?.metrics?.time_windows[''+selectedRange]['qc'] !== 0) {
              <sh-icon id="instrument-icon-warning" icon="warning"
              size="xs" color="var(--warning-icon-color)" style="cursor: help;" (click)="openHelp('QC')"></sh-icon>
            }
            <!-- <sh-icon id="instrument-icon-warning" *ngIf="this.moduleType === ''" icon="warning"
          size="xs" color="var(--warning-yellow)" style="cursor: help;" (click)="openHelp('QC')"></sh-icon> -->
          <div [ngClass]="'custom-info' + (moduleType === '' && !businessPartnerMode ? ' qc-disabled' : '')"
            [style.cursor]="businessPartnerMode ? 'default' : 'pointer'"
            (click)="goToATA()">
            <sh-text id="instrument-text-25" style="flex: 0 1 50px;" >{{ 'instrument.widget.qcIssues' | transloco }}</sh-text>
            @if (canOpenAta) {
              <sh-icon id="instrument-icon-open-link" icon="open-link" size="xs"></sh-icon>
            }
          </div>
          @if (moduleType === '' && !businessPartnerMode) {
            <sh-icon id="info-icon" icon="confirmation" button size="xs" style="cursor: help; margin-left: 4px;"></sh-icon>
          }
          <sh-popover id="instrument-popover-27" target="info-icon" type="warning">
            {{ 'instrument.widget.ataOnlyMessage' | transloco }}
          </sh-popover>
        </div>
        @if (systemhealth?.metrics && systemhealth?.metrics?.time_windows[''+selectedRange]['qc'] !== 0) {
          <div (click)="goToATA()"
            [style.cursor]="businessPartnerMode ? 'default' : 'pointer'"
            [ngClass]="'custom-tag' + (businessPartnerMode ? ' custom-tag--static' : '')">
          {{systemhealth?.metrics?.time_windows[''+selectedRange]['qc']}} {{ 'instrument.widget.errors' | transloco }}</div>
        }
      </div>
      <!-- <div [ngClass]="'custom-parent'">
      <div [ngClass]="'iconTextContainer'">
        <sh-icon id="instrument-icon-success" *ngIf="systemhealth.metrics.time_windows[''+selectedRange]['proactive_alerts'] === 0"
          icon="success" size="xs" color="#ebebeb" style="cursor: help;"
        (click)="openHelp('Proactive Alarms')"></sh-icon>
        <sh-icon id="instrument-icon-warning" *ngIf="systemhealth.metrics.time_windows[''+selectedRange]['proactive_alerts'] !== 0"
          icon="warning" size="xs" color="#FBBF28" style="cursor: help;"
        (click)="openHelp('Proactive Alarms')"></sh-icon>
        <sh-text id="instrument-text-30" [ngClass]="'custom-info'" style="cursor: pointer;"
        (click)="onMaximize('Proactive Alarms')">Proactive Alerts</sh-text>
      </div>
      <div (click)="onMaximize('Proactive Alarms')"
        *ngIf="systemhealth.metrics.time_windows[''+selectedRange]['proactive_alerts'] !== 0"
        [ngClass]="'custom-tag'">
      {{systemhealth.metrics.time_windows[''+selectedRange]['proactive_alerts'] + ' Alerts'}}</div>
    </div> -->
  </div>
}
@if (isError) {
  <sh-empty-state id="instrument-empty-state-error-retrieving-data" [attr.label]="'instrument.widget.error' | transloco" icon="error" icon-color="#ebebe"></sh-empty-state>
}

@if (isEmpty) {
  <sh-empty-state id="instrument-empty-state-no-data-found" [attr.label]="'instrument.widget.empty' | transloco" icon="information" icon-color="#ebebe"></sh-empty-state>
}

<!-- <sh-empty-state id="instrument-empty-state-select-a-serial-number-fi" *ngIf="!isLoading && !systemhealth && !isError && !isEmpty"
label="Select a Serial Number first to see System Information." icon="search"
icon-color="#ebebe"></sh-empty-state> -->

</sh-box-section>
@if (!isLoading && systemhealth) {
  <sh-box-footer id="instrument-box-footer-34" slot="footer" padding-top="0" padding-bottom="1rem">
    @if (getDeviceType() !== 'phone') {
      <sh-button id="instrument-button-details" (click)="onMaximize(null)" [icon]="checkWidgetIcon()" icon-position="right" icon-size="s"
      [attr.label]="'instrument.widget.details' | transloco" layout="compact" color="secondary" size="s"></sh-button>
    }
  </sh-box-footer>
}



</sh-box>